export enum DataType {
    STRING = 'string',
    NUMBER = 'number'
}
